import React from "react";
import { ECLTable } from "../../../index";
//Lots of mapping.  I suggest console.logging props and walking through the element tree
//of the react markdown if necessary to adjust this.
export default function ECLRichTextTable(props) {
   const reactMarkdownHeaders =
      props.children[0]?.props?.children[0]?.props?.children;
   let tableHeaders;
   if (reactMarkdownHeaders) {
      //Table header elements are listed under the first item in props.children
      tableHeaders = reactMarkdownHeaders.map((ch) => {
         //Empty headers will not have props.children content
         if (ch.props.children) {
            return ch.props.children;
         } else {
            return "";
         }
      });
   } else {
      //If headers don't exist, then something truly weird happened with React Markdown, we'll render nothing
      console.error("Malformed rich text table, file a ticket!");
      return null;
   }

   //If we can access the t-body area, then we can map as usual, otherwise, render as many items as
   //there are columns in the first row, with all values empty strings
   const reactMarkdownRows = props?.children[1]?.props?.children;
   let tableBodyRows;
   if (reactMarkdownRows) {
      tableBodyRows = props.children[1].props.children.map((ch) =>
         ch.props.children.map((el) => {
            //React Markdown does a fun thing where if you leave a table item blank, it'll pass no children
            //so when there are no children for a table item (td) prop, return a blank string
            if (el.props.children) {
               return el.props.children[0];
            }
            return "";
         }),
      );
   } else {
      tableBodyRows = [tableHeaders.map(() => "")];
   }

   return (
      <div
         className="rich-text-table-container"
         style={{
            minHeight: Math.min(tableBodyRows.length * 30 + 55, 200) + "px",
            width: tableHeaders.length * 150 + 15 + 2 + "px", //Padding + scrollbar + border
         }}
      >
         <ECLTable
            columnSettings={tableHeaders.map((c, i) => {
               return {
                  label: c,
                  id: "richtext" + c + i,
                  width: 150,
                  alignment: "left",
                  customFormatting: (rowIndex, value) => {
                     if (typeof value === "object") {
                        return (
                           <p className="string-trunc string-cell">
                              {value.props?.children[0]}
                           </p>
                        ); //Needs more thought, markdown value passed as a node instead of raw
                     }
                     return <p className="string-trunc string-cell">{value}</p>;
                  },
               };
            })}
            tableSettings={{
               columnOrder: tableHeaders.map((c, i) => "richtext" + c + i),
               columnHide: [],
               rowHeight: 30,
               tableHeight: tableBodyRows.length * 30 + 45 - 3, // Umm... borders?  Not sure where the extra pixel comes from, but looks best this way
            }}
            rowData={tableBodyRows.map((r) => {
               return {
                  row: r,
                  hide: false,
               };
            })}
         />
      </div>
   );
}
